var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("证件管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("证件管理"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "姓名" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入姓名",
                                  },
                                  model: {
                                    value: _vm.ruleForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "name", $$v)
                                    },
                                    expression: "ruleForm.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "证件类型" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择证件类型" },
                                    on: { change: _vm.selectCertificate },
                                    model: {
                                      value: _vm.ruleForm.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "status", $$v)
                                      },
                                      expression: "ruleForm.status",
                                    },
                                  },
                                  _vm._l(
                                    _vm.certificate,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.title,
                                          value: item.id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "等级" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "150px",
                                    },
                                    attrs: { placeholder: "选择等级" },
                                    model: {
                                      value: _vm.ruleForm.level,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "level", $$v)
                                      },
                                      expression: "ruleForm.level",
                                    },
                                  },
                                  _vm._l(_vm.ids, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.propDesc,
                                        value: item.propValue,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择状态" },
                                    model: {
                                      value: _vm.ruleForm.isJob,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "isJob", $$v)
                                      },
                                      expression: "ruleForm.isJob",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "未通过", value: "0" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已通过", value: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "待审核", value: "2" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList("new")
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "姓名", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("span", [_vm._v(_vm._s(scope.row.name))])]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "careerTypeName",
                    label: "证件类型",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "certNumber",
                    label: "证件编号",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "等级", align: "center", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.levelTypeName))]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "gmtCreate",
                    label: "审核状态",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              class: [
                                scope.row.verifyStatus == 0
                                  ? "redColor"
                                  : scope.row.verifyStatus == 1
                                  ? "greenColor"
                                  : "blueColor",
                              ],
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  scope.row.verifyStatus == 0
                                    ? "未通过"
                                    : scope.row.verifyStatus == 1
                                    ? "通过"
                                    : "待审核"
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "gmtCreate",
                    label: "创建时间",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    align: "center",
                    fixed: "right",
                    width: "180",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            scope.row.verifyStatus == 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                审核\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.verifyStatus != 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "operateBtn redColor1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.close(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                撤销审核\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.goDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "证件信息",
            visible: _vm.dialogVisible,
            width: "900px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "infoBox" }, [
            _c("div", { staticClass: "infoItem" }, [
              _vm._v("证件类型：" + _vm._s(_vm.selectData.careerTypeName)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _vm._v("证件等级：" + _vm._s(_vm.selectData.levelTypeName)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _vm._v("姓名：" + _vm._s(_vm.selectData.name)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "infoItem" }, [
              _vm._v("证件号：" + _vm._s(_vm.selectData.certNumber)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "infoItem",
                    staticStyle: { width: "200px", "margin-right": "20px" },
                  },
                  [
                    _c("el-image", {
                      attrs: {
                        src: _vm.selectData.certFrontUrl,
                        alt: "",
                        "preview-src-list": [_vm.selectData.certFrontUrl],
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "infoItem",
                    staticStyle: { width: "200px", "margin-right": "20px" },
                  },
                  [
                    _c("el-image", {
                      attrs: {
                        src: _vm.selectData.certOppositeUrl,
                        alt: "",
                        "preview-src-list": [_vm.selectData.certOppositeUrl],
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "infoItem", staticStyle: { width: "100%" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { "margin-right": "auto" },
                    attrs: { placeholder: "请选择审核状态" },
                    model: {
                      value: _vm.state,
                      callback: function ($$v) {
                        _vm.state = $$v
                      },
                      expression: "state",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "通过", value: "1" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "拒绝", value: "0" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.state == 1
              ? _c(
                  "div",
                  { staticClass: "infoItem", staticStyle: { width: "100%" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { "margin-right": "auto" },
                        attrs: { placeholder: "请选择等级" },
                        model: {
                          value: _vm.level,
                          callback: function ($$v) {
                            _vm.level = $$v
                          },
                          expression: "level",
                        },
                      },
                      _vm._l(_vm.ids, function (i, i1) {
                        return _c("el-option", {
                          key: i1,
                          attrs: { label: i.propDesc, value: i.propValue },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.state == "0"
              ? _c(
                  "div",
                  { staticClass: "infoItem" },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 2,
                        placeholder: "请输入拒绝原因",
                      },
                      model: {
                        value: _vm.textarea,
                        callback: function ($$v) {
                          _vm.textarea = $$v
                        },
                        expression: "textarea",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.shenhe()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }